export const MERGE_CELL_EMPTY_VALUE = 'empty'

export const MERGE_CELL_EMPTY_COLUMN = {
    title: "",
    id: MERGE_CELL_EMPTY_VALUE,
}